import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        position: 'relative',
        display: 'flex',
        // Mobile - image below content
        flexDirection: 'column-reverse',
        placeContent: 'center',
        overflow: 'hidden',
    },
    // Interflora
    image: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        minHeight: 'unset',
        paddingTop: '100%',
        [theme.breakpoints.up('xs')]: {
            paddingTop: 0,
        },
        '& img': {
            objectFit: 'cover',
        },
    },
    ffImage: {
        paddingTop: 0,
        marginTop: 'auto',
        '& img': {
            objectPosition: 'bottom right;',
            objectFit: 'contain',
        },
    },
    content: {
        display: 'flex',
        height: '100%',
        alignSelf: 'start',
        position: 'absolute',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
        },
    },
    contentInner: Object.assign(Object.assign({ margin: `${spacing.medium}`, [theme.breakpoints.up('sm')]: {
            marginBottom: spacing.medium,
        } }, (!theme.isFlyingFlowers && {
        [theme.breakpoints.up('sm')]: {
            margin: `${spacing.medium} 0 ${spacing.large} ${spacing.large}`,
        },
    })), { [theme.breakpoints.up('md')]: {
            margin: theme.isFlyingFlowers ? `${spacing.large}` : `${spacing.large} 0 ${spacing.xl} ${spacing.xl}`,
        } }),
    positionTop: {
        alignSelf: 'start',
    },
    positionCenter: {
        alignSelf: 'center',
        [`& .${classes.contentInner}`]: {
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
        },
    },
    positionBottom: {
        alignSelf: 'end',
    },
    heading: Object.assign(Object.assign(Object.assign({ display: 'flex', flexDirection: 'column' }, theme.typography.xl_bold), theme.typographySpacing.none), { color: colors.supplementary.white, [theme.breakpoints.up('sm')]: {
            marginBottom: spacing.small,
        }, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl), { marginBottom: spacing.small }), [theme.breakpoints.up('lg')]: {
            marginBottom: spacing.medium,
        }, [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), { marginBottom: spacing.large }), '& div:first-child': {
            color: theme.isFlyingFlowers ? undefined : colors.supplementary.white,
        } }),
    blogHeadingFF: Object.assign(Object.assign({ display: 'flex', flexDirection: 'column' }, theme.typographySpacing.none), { [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typography.xxl), { marginBottom: spacing.small }), [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl), { marginBottom: spacing.small }), [theme.breakpoints.up('lg')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xxl), theme.typographySpacing.none), { marginBottom: spacing.large }), [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.xxxxl) }),
    blogHeading: {
        '& h1': Object.assign(Object.assign(Object.assign({}, theme.typography.xl_regular), theme.typographySpacing.xl_regular_sm), { color: colors.supplementary.white, [theme.breakpoints.up('lg')]: Object.assign(Object.assign({}, theme.typography.xxl), theme.typographySpacing.xxxl_sm) }),
    },
    headingLine: {
        whiteSpace: 'nowrap',
        alignSelf: 'flex-start',
        padding: spacing.xs,
        '&:first-child': {
            transform: 'rotate(358deg) translate(5px,5px)',
            transformOrigin: 'bottom left',
        },
    },
    newHeading: {
        alignSelf: 'flex-start',
        display: 'block',
    },
    COBALT: {
        backgroundColor: colors.cobalt[500],
    },
    JADE: {
        backgroundColor: colors.jade[500],
    },
    WILD_EXOTIC: {
        backgroundColor: colors.wildExotic[500],
    },
    BLACK: {
        color: 'BLACK',
    },
    messageFF: Object.assign(Object.assign({ display: 'none' }, theme.typography.small_bold), { margin: '0', [theme.breakpoints.up('sm')]: {
            display: 'block',
        } }),
    message: Object.assign(Object.assign({ color: colors.supplementary.white }, theme.typography.small_bold), { margin: '0', paddingTop: '2px', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.medium_bold) }),
    outerMessage: {
        display: 'block',
        color: colors.black[700],
        [theme.breakpoints.up('sm')]: { display: 'none' },
    },
    centerHeading: {
        alignSelf: 'center',
    },
    ffCenterContentInner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    ffContent: {
        position: 'absolute',
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            position: 'relative',
            justifyContent: 'right',
        },
    },
    textCenter: {
        textAlign: 'center',
    },
    fontSohne: {
        [`& .${classes.heading}`]: Object.assign(Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xl_bold : theme.typography.xxl_bold)), (theme.isFlyingFlowers ? theme.typographySpacing.xl_bold_sm : theme.typographySpacing.xxl_bold_sm)), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xl_bold : theme.typography.xxxxl)), (theme.isFlyingFlowers ? theme.typographySpacing.xl_bold_sm : theme.typographySpacing.xxxxl_sm)) }),
        [`& .${classes.message},& .${classes.messageFF}`]: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_sm), { marginBottom: 0, paddingTop: !theme.isFlyingFlowers ? spacing.xxs : undefined, [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typographySpacing.none), { paddingTop: '2px' }), [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.medium_bold) }),
    },
    blogContainer: {
        placeContent: theme.isFlyingFlowers ? 'center' : 'start',
        [theme.breakpoints.down('xs')]: {
            maxHeight: '376px',
        },
    },
    mobilePositionOver: {
        [theme.breakpoints.down('sm')]: {
            [`& .${classes.image}`]: {
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
            },
            [`& .${classes.ffImage}`]: {
                position: 'relative',
            },
        },
    },
    fullWidthCoverFF: {
        paddingTop: '100%',
        height: '100%',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            paddingTop: 0,
        },
        '& img': {
            objectFit: 'cover',
            objectPosition: 'unset',
        },
    },
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
            [`& .${classes.image}.${classes.ffImage} img`]: {
                objectPosition: 'bottom right',
            },
            [`& .${classes.ffImagePosition} img`]: {
                objectPosition: 'bottom right',
            },
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            [`& .${classes.content}`]: {
                justifyContent: 'right',
                width: '50%',
            },
            [`& .${classes.image}.${classes.ffImage} img`]: {
                objectPosition: 'bottom left',
            },
            [`& .${classes.ffImagePosition} img`]: {
                objectPosition: 'bottom left',
            },
            [`& .${classes.fullWidthCoverFF}`]: {
                position: 'absolute',
            },
        },
    },
    fullWidth: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
    },
    imageSpacer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            width: '50%',
        },
    },
    headingColor: {
        color: (_params === null || _params === void 0 ? void 0 : _params.headingColor) ? `${colors.genericContentHeading[_params === null || _params === void 0 ? void 0 : _params.headingColor]}` : '',
    },
    textLeft: {
        textAlign: 'left',
    },
    textRight: {
        textAlign: 'right',
    },
    ffImagePosition: {
        [theme.breakpoints.down('sm')]: {
            '& img': {
                maxHeight: '335px',
            },
        },
        '& img': {
            objectPosition: 'bottom',
            objectFit: 'contain',
            [theme.breakpoints.up('sm')]: {
                objectPosition: 'bottom',
            },
        },
    },
    ffMobileheight: {
        '&': {
            minHeight: '640px',
            placeContent: 'start',
        },
    },
    ffMobileContent: {
        '& div[data-testid="desktopImage"]': {
            marginTop: 'auto',
        },
    },
    ffPosition: {
        '& div[data-testid="desktopImage"] button': {
            position: 'absolute',
        },
    },
    ffContentPosition: {
        [theme.breakpoints.up('sm')]: {
            width: '100%',
        },
    },
    blogPage: Object.assign(Object.assign(Object.assign({ color: colors.supplementary.white }, theme.typography.small_bold), theme.typographySpacing.small_bold_sm), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typographySpacing.small_regular_lg) }),
    blogArticlePage: Object.assign(Object.assign(Object.assign({ color: colors.supplementary.white }, theme.typography.small_bold), theme.typographySpacing.small_bold_sm), { fontWeight: '600 !important', marginBottom: '0 !important', [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm) }),
}));
export default useStyles;
